import { useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";

export default function MenuItem({
    icon,
    title,
    to,
    collapsed,
    condition = true,
    onClick = () => {},
    children
}) {
    const [active, setActive] = useState(false);

    const handleClick = () => {
        setActive(s => !s);
        onClick();
    };

    if (!condition) return null;

    // If there are children (submenu items), render a div instead of a Link
    // and handle the submenu display
    if (children) {
        return (
            <>
                <div className={`menu-item ${active ? 'active' : ''}`} onClick={handleClick}>
                    {collapsed ? (
                        <Tooltip title={title} placement="right">
                            <div className="menu-icon-only">
                                {icon}
                            </div>
                        </Tooltip>
                    ) : (
                        <div className="menu-content">
                            {icon}
                            <h3>{title}</h3>
                        </div>
                    )}
                    {!collapsed && (
                        <div style={{position: "relative", display: "flex", alignItems: "center", paddingRight: "1em"}}>
                            <span className="chevron-icon">
                                {active ? <DownOutlined/> : <RightOutlined/>}
                            </span>
                        </div>
                    )}
                </div>
                {!collapsed && (
                    <div className="submenu" style={{display: active ? "block" : "none"}}>
                        {children}
                    </div>
                )}
            </>
        );
    }

    // If there are no children, render a simple menu item with a Link
    return (
        <Link to={to}>
            <div className={`menu-item ${active ? 'active' : ''}`} onClick={handleClick}>
                {collapsed ? (
                    <Tooltip title={title} placement="right">
                        <div className="menu-icon-only">
                            {icon}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="menu-content">
                        {icon}
                        <h3>{title}</h3>
                    </div>
                )}
            </div>
        </Link>
    );
}
